import gql from "graphql-tag";

export default gql`
	mutation updateSubscriptionByIDV2($subscriptionID: Int!, $newSeats: Int!) {
		updateSubscriptionByIDV2(subscriptionID: $subscriptionID, newSeats: $newSeats) {
			... on Order {
				orderNumber
				totalAmount
			}

			... on UpdateSubscriptionByIDFailure {
				errorCode
				message
			}
		}
	}
`;

export const readUpdateSubscriptionResult = ({ data }) =>
	data && {
		...data.updateSubscriptionByIDV2,
	};
